import { MenuItem, Select } from 'apollo-react';
import React from 'react';

import { getActionMenuItems } from '../../utils/common.utils';

const ActionDropdownCell = ({ row, column: { accessor } }) => {
  const value = row[accessor];

  const menuItems = getActionMenuItems({ type: row.Type });
  const disabled = row.disableActionDropdown || !(menuItems.length > 1);

  const handleChange = ({ target: { value } }) => {
    row.editRow({ rowId: row.id, key: accessor, value });
  };

  return (
    <Select
      fullWidth
      size="small"
      canDeselect={false}
      value={value}
      disabled={disabled}
      onChange={handleChange}
    >
      {menuItems.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ActionDropdownCell;
